import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AdminComponent} from './admin.component';
import {AdminFooterComponent} from './admin-footer/admin-footer.component';
import {StandaloneViewResultComponent} from 'bos-commons';
import {LoggedUsersComponent} from './logged-users/logged-users.component';
import {AdminLinksComponent} from './admin-links/admin-links.component';
import {UserLoggedGuard} from './user-logged.guard';
import {AdminLoggedGuard} from './admin-logged.guard';
import {AdminSessionConfigComponent} from "./admin-session-config/admin-session-config.component";
import {AdminLevenshteinConfigComponent} from "./admin-levenshtein-config/admin-levenshtein-config.component";


const adminRoutes: Routes = [
  { path: 'admin', component: AdminComponent,
    canActivate: [UserLoggedGuard, AdminLoggedGuard],
    children: [
      {path: '', redirectTo: 'footer', pathMatch: 'full', canActivate: [UserLoggedGuard, AdminLoggedGuard]},
      {path: 'footer', component: AdminFooterComponent, canActivate: [UserLoggedGuard, AdminLoggedGuard]},
      {path: 'links', component: AdminLinksComponent, canActivate: [UserLoggedGuard, AdminLoggedGuard]},
      {path: 'sessions', component: LoggedUsersComponent, canActivate: [UserLoggedGuard, AdminLoggedGuard]},
      {path: 'sessionconfig', component: AdminSessionConfigComponent, canActivate: [UserLoggedGuard, AdminLoggedGuard]},
      {path: 'levenshteinconfig', component: AdminLevenshteinConfigComponent, canActivate: [UserLoggedGuard, AdminLoggedGuard]},
      {path: 'view/:target/:id', component: StandaloneViewResultComponent, canActivate: [UserLoggedGuard, AdminLoggedGuard]}
    ]
  }
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild(adminRoutes)
  ], exports: [
    RouterModule
  ]
})
export class AdminRoutingModule {
}
